import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const InputName = nameDecorator(InputSimple);
const InputPhone = phoneDecorator(InputSimple);

export const FormWrapper = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    height: auto;
    padding: 40px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgMain};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 40px 40px 24px;
    }
`;

export const BlockTitle = styled.h4`
    margin: 0;
    ${FONTS.H4};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
    }
`;

export const BlockSubtitle = styled.p`
    margin: 0;
    ${FONTS.S};

    a {
        color: ${COLORS.Link};
        transition: 0.3s;

        &:hover {
            color: ${COLORS.Brand_Blue};
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const InputDataBlock = styled.div`
    display: grid;
    grid-template-rows: repeat(2, 48px);
    grid-template-columns: repeat(6, 1fr);
    width: 100%;
    margin: 16px 0;
    gap: 8px 8px;

    input {
        padding-right: 16px;

        &::placeholder {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;

export const InputDealerName = styled(InputName)`
    grid-row: 1 / 2;
    grid-column: 1 / 3;
    margin-bottom: 0;
`;

export const InputDealerId = styled(InputSimple)`
    grid-row: 1 / 2;
    grid-column: 3 / 5;
    margin-bottom: 0;
`;

export const InputDealerMail = styled(InputSimple)`
    grid-row: 1 / 2;
    grid-column: 5 / -1;
    margin-bottom: 0;
`;

export const InputDealerPhone = styled(InputPhone)`
    grid-row: 2 / 3;
    grid-column: 1 / 4;
    margin-bottom: 0;
`;

export const DealerCitySelectWrapper = styled.div`
    grid-row: 2 / 3;
    grid-column: 4 / -1;
`;

export const InputClientName = styled(InputName)`
    grid-row: 1 / 2;
    grid-column: 1 / 4;
    margin-bottom: 0;
`;

export const InputClientPhone = styled(InputPhone)`
    grid-row: 1 / 2;
    grid-column: 4 / -1;
    margin-bottom: 0;
`;

export const ClientCitySelectWrapper = styled.div`
    grid-row: 2 / 3;
    grid-column: 1 / -1;
`;

export const ActionBlock = styled.div`
    width: 100%;
    flex-wrap: nowrap;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const SubmitButton = styled(BaseButton)`
    margin-right: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 0;
        margin-bottom: 10px;
    }
`;

export const PoliciesBlock = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex-direction: column;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex-direction: row;
    }

    @media (max-width: 591px) {
        flex-direction: column;
    }
`;
